<template>
  <div :class="classes" :style="style">
    <div class="submenu-wrapper">
      <div class="close-btn-container">
        <v-btn small @click="closeMenu(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-list dense class="submenu-list" :style="listStyle">
        <v-list-tile v-for="(item, i) in items" :key="i" :to="item.to" class="submenu-item"
                     active-class="" @click="click(item)">
          <v-list-tile-content class="submenu-item-content">{{ item.label }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>

<script>
  const SUBMENU_ITEM_HEIGHT = 40;

  export default {
    props: {
      visible: Boolean,
      position: Number,
      items: Array,
      centerpoint: Number,
      fullWidth: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      classes() {
        const classes = ['edval-submenu-drawer'];
        if (this.fullWidth) {
          classes.push('full-width');
        }

        return classes;
      },
      style() {
        const style = {
          left: `${this.position}px`
        };
        if (!this.visible) {
          style.width = 0;
        }

        return style;
      },
      listStyle() {
        const pxTop = Math.max(
          this.centerpoint -
            // Minus half the menu size to align centers
            // Calculating instead of reading from DOM so that we can render correctly the first
            // time, instead of having elements jump around as we re-calculate after DOM insertion
            (SUBMENU_ITEM_HEIGHT * this.items.length) / 2,
          60 // Must be at least 60px
        );

        return {
          marginTop: `${pxTop}px`
        };
      }
    },
    methods: {
      click(item) {
        if (item.click) {
          item.click();
        }
        this.closeMenu(true);
      },
      closeMenu(hasNavigated) {
        this.$emit('closeMenu', hasNavigated);
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../style/variables.less';

  .edval-submenu-drawer {
    height: 100%;
    position: fixed;
    background-color: @submenu-bg;
    z-index: @layer-3;
    overflow: hidden;
    width: @submenu-width;
    transition: @menu-ease-transition;
    transition-property: left, width;

    &.full-width {
      &, .submenu-wrapper {
        width: 100%;
      }
    }

    .submenu-wrapper {
      width: @submenu-width;
      position: absolute;

      .close-btn-container {
        position: absolute;
        right: 0;
        top: 0;

        .v-btn {
          color: @submenu-support-color;
          background-color: transparent;
          box-shadow: none;
          min-width: 0;
          margin: 20px;

          &:hover {
            color: @submenu-item-active-color;
            background-color: @submenu-item-active-bg;
          }

          .v-icon {
            font-size: 20px;
            font-weight: bold;
          }
        }
      }

      .submenu-list {
        /*margin-top: 60px;*/
        color: @submenu-text-color;
        background-color: transparent;
        padding: 0;
        border-width: 1px 0;
        border-style: solid;
        border-color: @edval-dark;

        .submenu-item {
          .submenu-item-content {
            font-family: @menu-font-family;
            font-weight: bold;
            font-size: 15px;
            padding-left: 10px;
          }

          &:hover {
            color: @submenu-item-active-color;
            background-color: @submenu-item-active-bg;
          }
        }
      }
    }
  }
</style>
